import axiosInstance from "../../utils/AxiosInstance";

export interface PlatformAdmin {
  id: string;
  fullName: string;
  email: string;
  securityLevel: number;
  companyId: string | null;
  companyName: string | null;
}

export interface CreateAdminBody {
  fullName: string;
  email: string;
}

export function listAdmins(): Promise<PlatformAdmin[]> {
  return axiosInstance.get<PlatformAdmin[]>("/admins").then((response) => response.data);
}

export function createAdmin(body: CreateAdminBody): Promise<PlatformAdmin> {
  return axiosInstance
    .post<PlatformAdmin>("/admins", {
      full_name: body.fullName,
      email: body.email,
    })
    .then((response) => response.data);
}

export function setSecurityScore(id: string, score: number): Promise<{ id: string; securityLevel: number }> {
  return axiosInstance
    .put<{ id: string; securityLevel: number }>(`/admins/${encodeURIComponent(id)}/security_score`, {
      security_score: score,
    })
    .then((response) => response.data);
}
